import React from "react";
import ImageBackCollection from "../../../../../assets/images/Event-2026/Rectangle86.png";
import ImageBackHome from "../../../../../assets/images/Event-2026/Rectangle85.png";
import styled from "styled-components";

export default function ButtonNavigate({ text1, text2, img1, img2, onClickLeft, onClickRight }) {
  return (
    <Container>
      <div className="container">
        <div className="menu-wrapper">
          <div className="menu-item menu-item_left" onClick={onClickLeft}>
            <div>
              <img src={img1} alt="" />
              <span>{text1}</span>
            </div>
          </div>

          <div className="menu-item menu-item_right" onClick={onClickRight}>
            <div>
              <span>{text2}</span>
              <img src={img2} alt="" />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}
const Container = styled.div`
  .container {
    margin-bottom: 20px;
    height: 50px;
    width: 100%;
    max-width: 1200px;
    margin: auto;
    
    @media (max-width: 768px) {
      height: 20px;
    }
  }
  .menu-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    gap: 5px;

    .menu-item {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      height: 70px;
      cursor: pointer;
      @media (max-width: 768px) {
        height: 45px;
      }

      div {
        display: flex;
        align-items: center;
        span {
          font-size: 20px;
          line-height: 23px;
          font-weight: 700;
          color: #fff;
          @media (max-width: 768px) {
            font-size: 13px;
            line-height: 16px;
            word-break: break-word;
            white-space: normal;
            display: inline-block;
            width: 160px;
          }
        }
      }
    }

    .menu-item_left {
      background-image: url(${ImageBackCollection});
      position: absolute;
      left: 20px;
      width: calc(100% - 48%);
      @media (max-width: 768px) {
        left: 10px;
        width: calc(100% - 48%);
      }
      div {
        position: absolute;
        left: 30px;
        top: 50%;
        transform: translateY(-50%);
        @media (max-width: 768px) {
          /* left: 10px; */
        }
        span {
          padding-left: 20px;
          @media (max-width: 768px) {
            padding-left: 10px;
          }
        }
        img {
          @media (max-width: 768px) {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
    .menu-item_right {
      background-image: url(${ImageBackHome});
      position: absolute;
      right: 20px;
      width: calc(100% - 48%);
      @media (max-width: 768px) {
        right: 10px;
        width: calc(100% - 48%);
      }
      div {
        position: absolute;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
        @media (max-width: 768px) {
          /* right: 10px; */
        }
        span {
          padding-right: 20px;
          @media (max-width: 768px) {
            padding-right: 10px;
            word-break: break-word;
            white-space: normal;
            display: inline-block;
            text-align: right;
          }
        }
        img {
          @media (max-width: 768px) {
            width: 25px;
            height: 25px;
          }
        }
      }
    }
  }
`;
